import { render } from "./PlayList.vue?vue&type=template&id=27153176&scoped=true"
import script from "./PlayList.vue?vue&type=script&lang=js"
export * from "./PlayList.vue?vue&type=script&lang=js"

import "./PlayList.vue?vue&type=style&index=0&id=27153176&scoped=true&lang=css"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27153176"]])

export default __exports__